import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc EnrollToEpost defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { EnrollToEpostService } from 'services/enrollToEpost';
 *
 * // create service instance and send/cancel request
 * const enrollToEpostService = new EnrollToEpostService();
 * const result = await enrollToEpostService.fetchData( '<user-id>' ); // fetch data
 * enrollToEpostService.cancel(); // cancel an active request
 */
export class EnrollToEpostService extends HttpService {

    // fetch call list data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            const steps = get( response, 'body.component.structure.steps', [] );
            const visibility = get( response, 'body.component.visibility', {} );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    steps: getVisibleItems( steps, visibility ),
                    currentStep: get( response, 'body.component.data.state.currentStep', 1 )
                }
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
